export default {
	introSectTitleHtml: `Effective Products <br>creation for everyone`,
	introSectList: {
		str1: `Develop Websites and Apps`,
		str2: `Design and product essence solution delivery`,
		str3: `Build marketing cross-platform strategy, based on 9 advertising channels`,
		str3TooltipTitle: `Build marketing <br>across 9 advertising channels:`,
		str3TooltipInner: `
      <ol>
        <li>Advertising in search engines (Yandex and Google)</li>
        <li>SMM (FB, Instagram, VK)</li>
        <li>SEO (blog, media, website optimization)</li>
        <li>YouTube ad</li>
      </ol>
    `,
	},
	introSectLink: 'Visit website',

	portfolioSectTitleHtml: `Check <b>our projects</b> <br class="d-none d-sm-block">to know us better`,
	viewPortfolio: 'View portfolio',
}
